export default {
    data () {
        return {
            course: {
                name: '',
                shop_id: ''
            },
            shopList: [
                {
                    shop_id: 1,
                    shop_name: '润沁教育'
                },
                {
                    shop_id: 2,
                    shop_name: '惠州人才热线'
                },
                {
                    shop_id: 3,
                    shop_name: '江门市新会区人力资源和社会保障局'
                },
                {
                    shop_id: 4,
                    shop_name: '韶关市培训平台'
                },
                {
                    shop_id: 5,
                    shop_name: '高校教师课程云超市'
                },
                {
                    shop_id: 6,
                    shop_name: '河源之窗继续教育网'
                },
                {
                    shop_id: 7,
                    shop_name: '教师研修社区'
                }
            ],
            tableData: [],
            pageSize: 15,
            currPage: 1,
            total: 0
        }
    },

    methods: {
        // 搜索
        search() {
            let data = {
                name: this.course.name,
                shop_id: this.course.shop_id,
                offset: (this.currPage - 1) * this.pageSize,
                length: this.pageSize
            }
            this.$post('products/search', data).then(res => {
                this.tableData = res.data.result.data
                this.total = res.data.result.total
            })
        },

        handleSizeChange(pageSize) {
            this.pageSize = pageSize
            this.search()
        },

        handleCurrentChange(currPage) {
            this.currPage = currPage
            this.search()
        }

    },

    created() {
        this.search()
    },
}